import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { NavigationConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationEnabledGuard implements CanActivate {
  private configService = inject(NavigationConfigService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    const { cueSolutionValidLicence, enabled } = this.configService.value;

    if (cueSolutionValidLicence && enabled) {
      return true;
    }

    return this.router.createUrlTree(['/not-enabled'], {
      queryParams: {
        cueSolutionValidLicence,
        enabled,
      },
    });
  }
}
